module.exports = __webpack_public_path__ + "static/media/sliderBackground.702ea3cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/ui/sliderBackground.png
// module id = 374
// module chunks = 0